import { NetworkClient, useClassFactory, useNetworkService } from "@pasta/box-v2";
import type { EnhanceSignatureDto } from "../dto/enhance-signature.dto";

export type EnhancedSignature = {
  url: string;
  originalWidth: number;
  originalHeight: number;
};

export class EnhanceSignatureApi {
  protected readonly baseEndpoint = `enhance-signature/`;

  protected get network(): NetworkClient {
    return useNetworkService();
  }

  async generateEnhancedSignature(options: EnhanceSignatureDto): Promise<EnhancedSignature> {
    const response = await this.network.post(this.baseEndpoint, options);
    return response.data;
  }
}

export const [enhanceSignatureApiToken, useEnhanceSignatureApi] = useClassFactory(EnhanceSignatureApi);
